const TARGET_RATIO = 9 / 16; // 0.5625
const TOLERANCE = 0.05; // ±5%

interface VideoMetadata {
  width: number;
  height: number;
  isVertical: boolean;
}

export function getVideoMetadata(file: File): Promise<VideoMetadata> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.src = URL.createObjectURL(file);

    video.onloadedmetadata = () => {
      const { videoWidth: width, videoHeight: height } = video;
      URL.revokeObjectURL(video.src);

      const ratio = width / height;
      const isVertical =
        ratio >= TARGET_RATIO * (1 - TOLERANCE) &&
        ratio <= TARGET_RATIO * (1 + TOLERANCE);

      resolve({ width, height, isVertical });
    };

    video.onerror = () => {
      URL.revokeObjectURL(video.src);
      reject(new Error('Kunne ikke lese videometadata.'));
    };
  });
}
